export default __webpack_public_path__ + "static/media/ha-logo.dcdf9be5.png";